<template>
  <div class="row card-double w-100">
    <div class="col-md-24 section-card">
      <div class="col-19">
        <div class="box-title ml-1">
          <svg width="40" height="40" class="mr-3">
            <image
              xlink:href="@/assets/icons/icon-diamante.svg"
              width="100%"
              height="100%"
              alt="icon diamante"
            />
          </svg>
          <div class="area-text">
            <h4  v-text="$ml.get('boostedProgram')">
              Campanha recompensa em dobro
            </h4>
            <div
              class="card-date"
              v-if="
                campaign_situation == 'in_progress' ||
                campaign_situation == 'approved'
              "
            >
              <svg width="20" height="20">
                <image
                  xlink:href="@/assets/icons/icon-calendario.svg"
                  width="100%"
                  height="100%"
                  alt="icon diamante"
                />
              </svg>
              <p>
                {{ $ml.get("remain") }} {{ campaignFinalDays }}
                <label v-if="start == 'start'"> {{ campaignDays }} {{
                  $ml.get("campaignFinalDays")
                }}</label>
                <label v-else>
                  {{ campaignDays }} {{
                  $ml.get("campaignInitialDays")
                }}</label
                >
              </p>
            </div>
            <div>
              <label
                v-if="
                  offers_double_bounty == true && offers_double_score == false
                "
                class="card-description"
                v-text="$ml.get('bountyOffer')"
                >Você está oferecendo: Bouties em dobro</label
              >
              <label
                v-text="$ml.get('bountyScore')"
                v-else-if="
                  offers_double_bounty == false && offers_double_score == true
                "
                class="card-description"
                >Você está oferecendo: Score em dobro</label
              >
              <label
                v-text="$ml.get('bountyAndScoreOffer')"
                v-else-if="
                  offers_double_bounty == true && offers_double_score == true
                "
                class="card-description"
                >Você está oferecendo: Bouties e score em dobro</label
              >
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-5 area-btn"
        v-if="
          campaign_situation == 'approved' ||
          campaign_situation == 'in_progress' ||
          campaign_situation == 'paused'
        "
      >
        <b-button
          v-if="campaign_situation != 'paused'"
          @click="statusDoubleCampaing('pause')"
          v-b-tooltip.hover
          :disabled="campaign_situation != 'in_progress'"
          :title="$ml.get('pauseCampaign')"
          class="btn btn-top btn-custom"
          style="background-color: #730ba9"
        >
          <svg width="16" height="16" class="d-flex">
            <image
              xlink:href="../../../../src/assets/icons/pause-white.svg"
              width="16"
              height="16"
            />
          </svg>
        </b-button>
        <b-button
          v-if="campaign_situation == 'paused'"
          @click="statusDoubleCampaing('resume')"
          v-b-tooltip.hover
          :title="$ml.get('reactivateCampaign')"
          class="btn btn-top btn-custom"
        >
          <svg width="16" height="16" class="d-flex">
            <image
              xlink:href="../../../../src/assets/icons/reactivate-campaign.svg"
              width="16"
              height="16"
            />
          </svg>
        </b-button>
        <b-button
          @click="statusDoubleCampaing('finish')"
          v-b-tooltip.hover
          :title="$ml.get('closeCampaign')"
          class="btn btn-top btn-cancel btn-custom"
        >
          <svg width="16" height="16" class="d-flex">
            <image
              xlink:href="../../../../src/assets/icons/icon-closed-red.svg"
              width="16"
              height="16"
            />
          </svg>
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Swal from "sweetalert2";
import ProgramService from "../../../services/program.service";
export default {
  name: "BaseCard",
  props: {
    campaign_initial_date: {
      type: String,
      required: false,
      default: null,
    },
    campaign_final_date: {
      type: String,
      required: false,
      default: null,
    },
    campaign_situation: {
      type: String,
      required: false,
      default: "",
    },
    changeProgram: {
      type: Function,
      required: false,
      default: () => {},
    },
    offers_double_bounty: {
      type: Boolean,
      required: false,
      default: false,
    },
    offers_double_score: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      id: "",
    };
  },
  computed: {
    campaignFinalDays() {
      const now = moment();
      let today = moment(now, "DD/MM/YYYY").format("YYYYMMDD");
      let initialDate = moment(this.campaign_initial_date, "YYYY-MM-DD").format(
        "YYYYMMDD",
      );
      let finalDate = moment(this.campaign_final_date);
      if (today >= initialDate) {
        initialDate = moment(today);
        return finalDate.diff(initialDate, "days");
      } else if (initialDate > today) {
        initialDate = moment(this.campaign_initial_date);
        return initialDate.diff(today, "days");
      }
      return "Campanha encerrada";
    },

    start() {
      const now = moment();
      let today = moment(now, "DD/MM/YYYY").format("YYYYMMDD");
      let initialDate = moment(this.campaign_initial_date, "YYYY-MM-DD").format(
        "YYYYMMDD",
      );
      if (today >= initialDate) {
        return "start";
      } else if (initialDate > today) {
        return "pending";
      }
      return "finished";
    },

    campaignDays() {
      const now = moment();
      let today = moment(now, "DD/MM/YYYY").format("YYYYMMDD");
      let initialDate = moment(this.campaign_initial_date, "YYYY-MM-DD").format(
        "YYYYMMDD",
      );
      let day = "";
      let finalDate = moment(this.campaign_final_date);
      if (today >= initialDate) {
        initialDate = moment(today);
        day = finalDate.diff(initialDate, "days") == "1" ? this.$ml.get('day') : this.$ml.get('days');
        return day;
      } else if (initialDate > today) {
        initialDate = moment(this.campaign_initial_date);
        day = initialDate.diff(today, "days") == "1" ? this.$ml.get('day')  : this.$ml.get('days');
        return day;
      }
      return "Campanha encerrada";
    },
  },

  created() {
    this.id = this.$route.fullPath.split("?")[1];
  },

  methods: {
    async statusDoubleCampaing(status) {
      const self = this;
      const doubleCampaignClosed = self.$ml.get("doubleCampaignClosed")
      const doubleCampaignResumed = self.$ml.get("doubleCampaignResumed")
      try {
        const text =
          status == "pause"
            ? self.$ml.get("campaignPaused")
            : status == "finish"
            ? doubleCampaignClosed
            : doubleCampaignResumed;

        Swal.fire({
          icon: "success",
          title: text,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });

        await ProgramService.putProgramCampaign(this.id + `/${status}`);
        this.changeProgram(this.$route.fullPath.split("?")[1]);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.card-double {
  padding: 10px;
  box-shadow: 0px 3px 6px 2px #cecbd03a;
  margin-bottom: 40px;
}
.box-title {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  @media (max-width: 600px) {
    justify-content: center;
  }
}

.section-card {
  height: 100%;
  display: flex;
  padding: 10px;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 570px) {
    flex-direction: column;
  }
}
.area-btn {
  display: flex;
  justify-content: flex-end;
  gap: 10px;

  @media (max-width: 1000px) {
    flex-direction: column;
    align-items: flex-end;
  }

  @media (max-width: 570px) {
    margin-top: 20px;
    justify-content: center;
    flex-direction: row;
  }
}
.btn-custom {
  max-width: 65px;
}
.card-date {
  display: flex;
  gap: 10px;
  align-items: center;
  font-weight: 400;
  color: #999999;
  margin-bottom: 10px;
}
.card-date > p,
label {
  text-align: center;
  font-size: 1rem;
  margin: 0px;
  padding: 0px;
  color: #999999;

  @media (max-width: 570px) {
    font-size: 0.9rem;
    margin: 0px;
    padding: 0px;
  }
}
.card-description {
  font-size: 0.9rem;
  color: #6c757d;
}

.btn-cancel {
  background: white;
  border: 1px solid red;
}
.area-text{
  @media (max-width: 570px) {
    text-align:center
  }
}
.area-text > h4{
  font-size: 1.2rem;
}
</style>
